import { render } from "./contaspagar-detalhado-list.vue?vue&type=template&id=3dd62c39"
import script from "./contaspagar-detalhado-list.vue?vue&type=script&lang=js"
export * from "./contaspagar-detalhado-list.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__